<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3 v-if="tur == 'Fatura'">Fatura Ara</h3>
        <h3 v-if="tur == 'Sipariş'">Sipariş Ara</h3>
        <h3 v-if="tur == 'Teklif'">Teklif Ara</h3>
        <h3 v-if="tur == 'Ariza'">İade Teklif Ara</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="2" sm="5">
            <b-form-datepicker id="datepickerbaslangic" v-model="datepickerbaslangic" local="en" today-variant="danger"
              :placeholder="placeholderbaslangic" :start-weekday="weekday" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }" />
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-datepicker id="datepickerbitis" v-model="datepickerbitis" :placeholder="placeholderbitis" local="en"
              today-variant="danger" :start-weekday="weekday" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }" />
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-input v-model="arananDeger" @keyup.enter="listeleTop" id="smallInput" placeholder="Arama..." />
          </b-col>
          <b-col lg="2" sm="5">
            <v-select v-model="secilenDurum" :options="durumList" label="name" placeholder="Aktif" style=""
              @input="listeleTop()">
            </v-select>
          </b-col>
          <b-col lg="2" sm="5">
            <ButtonPrimary :title="title" :size="size" @test-click="listeleTop" />
          </b-col>
          <b-col v-if="tur == 'Ariza' || tur == 'Teklif'" lg="2" sm="2">
            <ButtonPrimary :title="yenititle" :size="size" :color="danger" @test-click="yeniEkle" />
          </b-col>
        </b-row>
      </div>
    </vs-card>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import TablesComponent from "./TablesComponent.vue";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";
import router from "../../../../router";
export default {
  props: ["gelentur", "Ty"],
  created() {
    this.datePick();
    this.turAl = this.gelentur;

    this.tur = this.gelentur;
  },
  components: {
    ButtonPrimary,
    TablesComponent,
    "v-select": vSelect
  },
  data() {
    return {
      weekday: 1,
      danger: "danger",
      yenititle: "Yeni",
      size: "",
      title: "Listele",
      secilenDurum: "",
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      placeholderbitis: "",
      datepickerbitis: "",
      arananDeger: "",
      tur: "",
      turAl: "",
      durumList: [
        { name: "Aktif", val: 2 },
        { name: "Pasif", val: 3 },
        { name: "İptal", val: 4 }
      ]
    };
  },
  mounted() {
    this.$root.$on("topcontent", () => {
      // your code goes here
      this.datePick();
    });
  },
  methods: {
    yeniEkle() {
      if (this.tur == "Ariza") {
        var kontrol = "yeni";
        localStorage.setItem("IADEARIZA_DETAY_KONTOL", kontrol);

        let routeData = this.$router.resolve({
          name: "SatinalmaIadearizaDetay",
          params: { kontrol: kontrol }
        });
        window.open(routeData.href, "_blank");
      }
      if (this.tur == "Teklif") {
        var Ty = this.Ty;
        let routeData = this.$router.resolve({
          name: "SatisSiparisTeklifleriTy", params: { Ty: Ty }
        });
        console.log(routeData)
        window.open(routeData.href, "_blank");
      }
    },
    getTahsilatRaporList() { },
    listeleTop() {
      //global olak tanımlanan tables metodu çağırılıyor. tanımlama->TablesCamponent.vue
      this.$root.$emit("tables");
      this.datePick();
console.log("test")
      this.$parent.satinAlma();
    },
    datePick() {
      var bitis, baslangic;

      if (this.datepickerbaslangic == "") {
        var baslangic2 = this.getLastTreeMonth();
        baslangic = moment(String(baslangic2)).format("MM.DD.YYYY");
        this.placeholderbaslangic = moment(String(baslangic2)).format(
          "DD.MM.YYYY"
        );
      } else {
        baslangic = moment(String(this.datepickerbaslangic)).format(
          "MM.DD.YYYY"
        );
        this.placeholderbaslangic = moment(String(baslangic)).format(
          "DD.MM.YYYY"
        );
      }

      if (this.datepickerbitis == "") {
        bitis = this.getNow();
        this.placeholderbitis = moment(String(bitis)).format("DD.MM.YYYY");
      } else {
        bitis = moment(String(this.datepickerbitis)).format("MM.DD.YYYY");
        this.placeholderbaslangic = moment(String(bitis)).format("DD.MM.YYYY");
      }
      if (typeof this.secilenDurum.val == "undefined") {
        this.$emit("secilenDurum", "2");
      } else {
        this.$emit("secilenDurum", this.secilenDurum.val);
      }
      this.$emit("bitis", bitis);
      //tarih değerlerini parent a gönder
      this.$emit("baslangic", baslangic);
      this.$emit("aranan", this.arananDeger);

      // this.$emit("secilenDurum", this.secilenDurum);
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 2);
      return new Date(d);
    },
    getNow() {
      const today = new Date();
      const date =
        today.getMonth() +
        1 +
        "." +
        today.getDate() +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    }
  }
};
</script>
